module.exports = __webpack_public_path__ + "img/Contacto 768px.52a60bdc.png";